import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MidPageCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.7
  }} className="py-10 px-5 max-w-2xl mx-auto text-center" data-id="element-237">
      <div className="border border-gold-400/20 rounded-2xl p-6 bg-gold-400/5" data-id="element-238">
        <p className="font-serif text-xl text-cream-50 mb-2" data-id="element-239">
          Ready to stop negotiating?
        </p>
        <p className="text-cream-100/50 text-sm mb-5" data-id="element-240">
          Instant download. Use it tonight.
        </p>
        <button onClick={scrollToPricing} className="inline-flex items-center gap-2 bg-gold-400 hover:bg-gold-500 text-[#0f1629] font-bold py-3 px-7 rounded-xl transition-colors duration-200 text-sm" data-id="element-241">
          Get it for $6.36 <ArrowRight className="w-4 h-4" data-id="element-242" />
        </button>
      </div>
    </motion.div>;
}